import SearchBarResultItem from './SearchBarResultItem';
import ShopByCategorySection from './ShopByCategorySection';
import { useContext } from 'react';
import SearchContext from '^/SearchContext';
import AutocompleteItem from './AutocompleteItem';
import ProductOptionListItem from './ProductOptionListItem';
const SearchBarResults = () => {
  const {
    searchResults,
    search,
    autocomplete = [],
    setAutocomplete
  } = useContext(SearchContext);


  const parsedList = searchResults.products?.map(each => (
    <SearchBarResultItem
      {...each}
      key={each.id}
    />
  ))
  const parsedAutocomplete = autocomplete.length ? autocomplete?.map(each => (
    <AutocompleteItem
      key={each.id}
      each={each}
      search={search}
    />


  )) : <AutocompleteItem
    each={{
      name: search
    }}
  />

  const parsedOptions = Object.entries(searchResults.product_options).map(([key = 'Vehicle', value]) =>
    <ProductOptionListItem
      key={key}
      name={key}
    />
  )

  return (

    <div className='search-bar-results'>
      <div className='search-results-container'>
        <div className="search-terms">			<ul class="ss-list">
          {parsedAutocomplete}
          {/* <li class="ss-list-option ng-scope search-facet-active">
            <a ng-bind-html="term.label | trusted" ss-no-ps="" ss-nav-selectable="" ng-focus="term.preview()" href="https://danasafetysupply.com/shop/?search_query=dash" class="ss-list-link ng-binding">da<strong>sh</strong></a>				</li>
          <li class="ss-list-option ng-scope">
            <a ng-bind-html="term.label | trusted" ss-no-ps="" ss-nav-selectable="" ng-focus="term.preview()" href="https://danasafetysupply.com/shop/?search_query=dashboard" class="ss-list-link ng-binding">da<em>shboard</em></a>				</li>
          <li class="ss-list-option ng-scope">
            <a ng-bind-html="term.label | trusted" ss-no-ps="" ss-nav-selectable="" ng-focus="term.preview()" href="https://danasafetysupply.com/shop/?search_query=data-link" class="ss-list-link ng-binding">da<em>ta-link</em></a>				</li>
          <li class="ss-list-option ng-scope">
            <a ng-bind-html="term.label | trusted" ss-no-ps="" ss-nav-selectable="" ng-focus="term.preview()" href="https://danasafetysupply.com/shop/?search_query=damascus" class="ss-list-link ng-binding">da<em>mascus</em></a>				</li> */}
        </ul>
        </div>
        <div className='results-content'>
          <div className="search-facets">
            <div ng-repeat="facet in ac.facets | filter:{ type: '!slider' } | limitTo:3 track by $index" ng-switch="facet.type" ng-if="facet.values.length" id="ss-ac-ss_category" class="ss-ac-facet-container ng-scope ss-ac-facet-container-list" ng-class="{'ss-ac-facet-container-list': (facet.type != 'grid' || facet.type != 'palette' || !facet.type), 'ss-ac-facet-container-palette': facet.type == 'palette', 'ss-ac-facet-container-grid': facet.type == 'grid'}">					<h4 class="search-bar-results-title ng-binding">Shop by Category</h4>
              <ul ng-switch-default="" class="ss-list ng-scope">
                <ShopByCategorySection
                  list={searchResults.categories}
                />
              </ul>
            </div>
            {/* <ProductOptionListItem
              name={ }
            /> */}
            {parsedOptions}
            
          </div>
          <div className='search-results'>
            <h4 class="search-bar-results-title">Product Suggestions</h4>
            <ul class="ss-ac-item-container">
              
              {parsedList}
            
            </ul>
          </div>
          <div class="search-see-more see-more-padding">
            <a href={"/products?search_query=" + search} class="" >
              See {searchResults.count} filtered result{searchResults.count === 1 ? '' : 's'} for "{search}"
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SearchBarResults;